import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";
import Pagination from "react-js-pagination";
import { Link, Routes, Route, useParams, useNavigate } from "react-router-dom";
import Committeegnb from "./Committeegnb";
import "../../pages/Main.scss";
import "../../pages/Board/Notice.scss";
import "../../lib/form/form.scss";
import "../Sub";
import ConfirmModal from "../../components/ConfirmModal";
import CommiitteeInfoDetail from "./CommitteeInfoDetail";
function Committeeprocess2() {
  let navigate = useNavigate();
  const { id } = useParams();
  const [commPostData, setCommPostData] = useState([]);
  const [page, setPage] = useState(1);
  const [filterType, setFilterType] = useState("init");
  const [filterInput, setFilterInput] = useState("");
  const [records, setRecords] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [filterModal, setFilterModal] = useState(false);
  const [filterValidateModal, setFilterValidateModal] = useState(false);

  // 검색 필터 타입
  const onChangeFilterType = (e) => {
    setFilterType(e.target.value);
  };
  const onChangeFilterInput = (e) => {
    setFilterInput(e.target.value);
  };
  const onClickFilter = () => {
    // console.log(`onClick filterType = ${filterType}`);
    // console.log(`onClick filterInput = ${filterInput}`);
    if (filterType === "init") {
      // alert("검색필터를 선택하세요.");
      setFilterModal(true);
      setFilterInput("");
      getCommInfoData();
    } else if (filterType === "timesLike" && filterInput.length === 0) {
      setFilterValidateModal(true);
    } else {
      setPage(0);
      PageFilterReplace();
    }
  };
  const PageFilterReplace = () => {
    // console.log(`page = ${page}`);
    getCommInfoData();
  };
  const handlePageChange = (page) => {
    getCommInfoData(page);
    setPage(page);
  };
  const openModal = (e) => {
    e.preventDefault();
    setFilterModal(true);
  };
  const closeModal = (e) => {
    e.preventDefault();
    setFilterModal(false);
    setFilterValidateModal(false);
  };

  const getCommInfoData = async (pageNum) => {
    try {
      if (pageNum === undefined) pageNum = 1;
      let params = {
        pageNumber: pageNum,
        committeeTypeId: id,
        pageSize: 15,
        timesLike: filterInput,
      };
      const response = await axios(`/api/committee-meeting-board`, {
        params: params,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      setCommPostData(response.data.data);
      setRecords(response.data);
      setTotalItems(response.data.recordsFiltered);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCommInfoData();
  }, [id]);

  return (
    <>
      {filterModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"검색 필터"}
          content={`검색 필터를 선택해 주세요.`}
        />
      ) : null}
      {filterValidateModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"검색어 입력"}
          content={`검색어를 입력해 주세요.`}
        />
      ) : null}
      <Committeegnb />
      <Routes>
        <Route path=":id" element={<CommiitteeInfoDetail />} />
      </Routes>
      <div className="">
        <div className="">
          <form className="my_page bbs_contain">
            <div className="row_bbs bbs_customqa_wrap">
              <div className="search_box">
                <div className="select_box">
                  <select
                    name="all"
                    onChange={onChangeFilterType}
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      검색필터
                    </option>
                    <option value="timesLike">회의차수</option>
                  </select>
                </div>

                <div className="input_wrap">
                  <input
                    className="input_line"
                    type="search"
                    placeholder="검색어를 입력하세요."
                    value={filterInput}
                    onChange={onChangeFilterInput}
                  />
                  <button
                    className="btn_color"
                    type="button"
                    onClick={onClickFilter}
                  >
                    검색
                  </button>
                </div>
              </div>

              <table className="table_wrap_customerqa">
                <thead>
                  <tr>
                    <th style={{ flex: "0.1" }}>번호</th>
                    <th style={{ flex: "0.2" }}>회의차수</th>
                    <th style={{ flex: "0.4" }}>제목</th>
                    <th style={{ flex: "0.2" }}>담당자</th>
                    <th style={{ flex: "0.3" }}>등록일</th>
                  </tr>
                </thead>
                <tbody>
                  {commPostData.map((value) => {
                    return (
                      <tr className="tr_hover" key={value.id}>
                        <td style={{ flex: "0.1" }}>{value.num}</td>
                        <td style={{ flex: "0.2" }} className="num_bbs">
                          {value.times}
                        </td>
                        <td style={{ cursor: "pointer", flex: "0.4" }}>
                          <p
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(
                                `/committeeprocess/${value.committeeTypeId}/info/${value.id}`
                              );
                            }}
                          >
                            {value.title}
                          </p>
                        </td>
                        <td style={{ flex: "0.2" }}>
                          <p className="auth">{value.createId}</p>
                        </td>
                        <td style={{ flex: "0.3" }} className="date_bbs">
                          {value.createAt}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {commPostData.length > 0 ? null : (
                <span style={{ textAlign: "center", marginTop: "10vh" }}>
                  등록된 목록이 없습니다
                </span>
              )}
              <div className="pagination_wrap">
                <div></div>
                <div className="pagination">
                  <Pagination
                    activePage={page}
                    itemsCountPerPage={15}
                    totalItemsCount={totalItems}
                    pageRangeDisplayed={15}
                    onChange={handlePageChange}
                    prevPageText={"‹"}
                    nextPageText={"›"}
                  />
                </div>
                <div>
                  <button
                    style={{ visibility: "hidden" }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/breakdown/cits");
                    }}
                    className="list_btn"
                  >
                    {/* 목록 */}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Committeeprocess2;
